import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COURSES } from "./homeData";
import { SectionHeading } from "./SectionHeading";

export const CoursesSection = () => (
  <section className="relative py-24 md:py-32 bg-dream-surface overflow-hidden" data-testid="lessons-highlight">
    <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-dream-violet/10 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 relative">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <SectionHeading eyebrow="Learn From Working Pros" title="Production & DJ courses." sub="1-on-1 mentorship with producers and DJs who are releasing and playing right now. Afterpay & Zip Pay available." />
        <Link to="/lessons">
          <Button variant="outline" className="border-white/20 text-white hover:border-white bg-transparent rounded-full px-6" data-testid="home-lessons-all-btn">
            All course details <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {COURSES.map((c, i) => (
          <motion.div key={c.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}>
            <Link
              to={`/lessons#mentor-${c.slug}`}
              className={`group block relative aspect-[4/5] rounded-3xl overflow-hidden border border-white/10 ${c.border} transition-colors`}
              data-testid={`home-course-${c.slug}`}
            >
              <img src={c.photo} alt={c.mentor} loading="lazy" className={`absolute inset-0 w-full h-full object-cover ${c.photoPos} transition-transform duration-700 group-hover:scale-105`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <ArrowUpRight className="absolute top-5 right-5 w-6 h-6 text-white/70 group-hover:text-white group-hover:rotate-45 transition-transform" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className={`font-mono text-xs uppercase tracking-widest ${c.accent}`}>{c.mentor}</p>
                <h3 className="font-heading text-2xl font-bold text-white mt-1 leading-tight">{c.title}</h3>
                <div className="flex items-end justify-between mt-4">
                  <p className="text-white/55 text-sm">{c.meta}</p>
                  <p className="font-heading text-3xl font-extrabold text-white" data-testid={`home-course-${c.slug}-price`}>{c.price}</p>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
